module.exports = __webpack_public_path__ + "static/media/protecao-tablet_new.a5ba9a47.svg";